/**
파일명: contactFormConstants.js
설명: 문의 폼 훅에서 공통으로 사용하는 상태값, API 경로, 기본 폼/에러 상수를 정의합니다.
*/

export const STATUS_COMPLETED = '답변완료';
export const STATUS_CONFIRMED = '확인 완료';
export const STATUS_REVIEWING = '검토중';

// [기술] 개발 환경에서는 CRA 프록시(package.json의 "proxy")가 9096으로 포워딩하므로 절대 URL 불필요
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';

export const inquiryApiUrl = `${apiBaseUrl}/api/inquiry`;

export const initialErrors = {
  title: '',
  company: '',
  manager: '',
  contact: '',
  email: '',
  privacyAgreed: '',
  message: '',
};

export const createInitialFormState = (defaultInquiryType = '') => ({
  inquiryType: defaultInquiryType,
  title: '',
  company: '',
  manager: '',
  contact: '',
  email: '',
  privacyAgreed: false,
  message: '',
});

export const requiredFieldLabels = {
  title: '제목',
  company: '회사명',
  manager: '담당자명',
  contact: '연락처',
  email: '이메일',
  message: '문의 내용',
};

export const contactPattern = /^[0-9-]+$/;
